<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import feedbackMixin from '../mixins/feedback'
import {ValidationProvider} from 'vee-validate';

Vue.use(VueAxios, axios);

export default {
	name: "BaseEdit",
	mixins: [feedbackMixin],
	components: {
		ValidationProvider
	},
	props: {
		record: {
			type: Object,
			default: {
				fieldData: {}
			}
		},
		entity: String,
		recordId: String,
		locked: Boolean
	},
	methods: {
		getRecord: function (recordId) {
			return Vue.axios.get('/3ds/api/' + this.entity + '/' + recordId, {
				headers: {
					'Authorization': 'Bearer ' + this.token
				}
			})
		},
		save: function (dirtyFields = null) {
			this.clearErrors();
			Vue.axios.patch('/3ds/api/' + this.entity + '/' + this.recordId,
				dirtyFields,
				{
					headers: {
						'Authorization': 'Bearer ' + this.token
					}
				}
			)
				.then(value => {
					console.log('Successfully updated record');
					console.log(JSON.stringify(value));
					this.$emit('update-record', {
						recordId: this.recordId
					})
				})
				.catch(reason => {
					console.log(JSON.stringify(reason));
					this.authCheck(reason)
				})
		},
		isEmptyObject: function (o) {
			for (let i in o) {
				if (o.hasOwnProperty(i)) {
					return false;
				}
			}
			return true;
		}
	},
	mounted: function () {
		this.$emit('set-edit-mode', {editMode: true});
	}
}
</script>

<style scoped>
.job-row > div > div {
    min-height: 24px;
}

input.form-control {
    height: 28px;
    width: 100%;
}

select.form-control {
    height: 28px;
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;
}

.job-field {
    margin-bottom: 6px;
    min-height: 24px;
}

.card-header {
    min-height: 40px !important;
}
</style>